import { useState, useCallback } from 'react';

export const useAlert = () => {
  const [alert, setAlert] = useState(null);

  const showAlert = useCallback((alertObj) => {
    setAlert(alertObj);
    setTimeout(() => setAlert(null), 4000);
  }, []);

  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  return {
    alert,
    showAlert,
    hideAlert
  };
}; 